export default {
      id: "insights-usage",
      viewBox: "0 0 35 28",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#insights",
      toString: function () {
        return this.url;
      }
    }